import { createStyles } from '@lib/style';
import { StyleSheet, Platform } from 'react-native';

export const styles = createStyles(() => ({
  linearCard: {
    borderRadius: 8,
  },
  container: {
    //maxWidth: 400,
    width: '100%',
    borderRadius: 8,
    padding: 15,
    paddingRight: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
